import AppConfig from '@/app.config.js'
import axios from 'axios';
import auth from "@/services/authService"
//import router from '@/router'
import EventBus from "@/services/eventBusService"

//axios.defaults.headers.common['Authorization'] = localStorage.getItem(AppConfig.auth.accessToken);

axios.interceptors.request.use(async (config) => {
  config.headers.Authorization = 'Bearer ' + localStorage.getItem(AppConfig.auth.accessToken)
  config.withCredentials = true
  return config;
}, function(error) {
  // Do something with request error
  return Promise.reject(error);
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error.response) {
      EventBus.$emit('network-error', true)
    } else
    if (error.response.status === 401) {
      auth.logout();
      //router.push('/login');
    }
    return Promise.reject(error.data);
  }
);

export default axios
